import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import ErrorState from "../../components/ErrorState/ErrorState";
import { reportError } from "../../helper/reportError";

interface ErrorPageProps {
  /**
   * Set when rendering outside a route error context, where `useRouteError`
   * has nothing to return.
   */
  error?: unknown;
}

function ErrorPage({ error }: ErrorPageProps = {}) {
  const routeError: unknown = useRouteError();
  const displayedError = error ?? routeError;

  useDocumentTitle("Error");

  useEffect(() => {
    reportError(displayedError, { source: "ErrorPage" });
  }, [displayedError]);

  return (
    <ErrorState
      error={displayedError}
      onRetry={() => window.location.reload()}
    />
  );
}

export default ErrorPage;
